<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item "><router-link to="/">Home</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Editando notificación</li>
            </ol>
        </nav>
        <div class="container">
            <div v-if="successMessage" class="alert alert-success" role="alert">
                {{ successMessage }}
            </div>
            <div v-if="errorMessages.length" class="alert alert-danger" role="alert">
                <p v-for="message in errorMessages" :key="message">{{ message }}</p>
            </div>
            <!--<div  >{{ notification }}</div>-->
            <h1 class="text-center">Edici&oacute;n de notificación mostrada en SCR y comunicaciones</h1>
            <form>
                <section>
                    <div class="form-group">
                        <!-- Nombre -->
                        <label for="name" class="font-weight-bold">Nombre de la notificación<sup>*</sup></label>
                        <text-area
                                @update="onNameUpdate"
                                name="name"
                                id="name"
                                rows="1"
                                :value="notification.name"
                        />
                    </div>
                    <div class="form-group">
                        <!-- Tipo -->
                        <label for="type" class="font-weight-bold">Tipo de notificación<sup>*</sup></label>
                        <type-selector
                                @update="onTypeUpdate"
                                :selectedValue="notification.type"
                        />
                    </div>

                    <div class="form-group">
                        <!-- Descripcion/Notas -->
                        <label for="description" class="font-weight-bold">Descripción de la notificación</label>
                        <text-area
                                @update="onDescriptionUpdate"
                                name="description"
                                id="description"
                                rows="2"
                                :value="notification.description"
                        />
                    </div>
                    <div class="form-group">
                        <!-- Id etiqueta -->
                        <label for="name" class="font-weight-bold">Id de etiqueta del texto de la notificación<sup>*</sup></label>
                        <label-input
                                @update="onLabelIdUpdate"
                                :selectedValue="notification.labelId"
                        />
                    </div>
                    <div class="form-group">
                        <!-- Activado Si/No -->
                        <label for="enabled" class="font-weight-bold">Notificación activada</label>
                        <div>
                            <toggle-switch
                                    @update="onEnabledUpdate"
                                    name="enabled"
                                    id="enabled"
                                    :checked="enabledIsChecked"
                            />
                        </div>
                        <p>S&oacute;lo se tendr&aacute;n en cuenta las notificaciones si est&aacute;n activadas.</p>
                    </div>
                </section>
                <!-- Reglas -->
                <section>
                    <h2>Reglas</h2>
                    <p>Se debe configurar al menos una regla. La notificación se mostrará en el SCR y/o las comunicaciones si se cumplen todas las reglas configuradas.</p>
                    <div class="form-group">
                        <!-- Tipo de compra -->
                        <label for="purchase_main_type" class="font-weight-bold">Aplica a los siguientes tipos principales de compra</label>
                        <purchase-main-type-selector
                                @error="onComponentError"
                                @update="onPurchaseMainTypeUpdate"
                                :selectedValues="selectedPurchaseMainTypes"
                                id="purchase_main_type"
                                name="purchase_main_type"
                                placeholder="Selecciona tipos de compra"
                        />
                    </div>
                    <div class="form-group">
                        <!-- NO Tipo de compra -->
                        <label for="not_purchase_main_type" class="font-weight-bold">NO aplica a los siguientes tipos principales de compra</label>
                        <purchase-main-type-selector
                                @error="onComponentError"
                                @update="onNotPurchaseMainTypeUpdate"
                                :selectedValues="selectedNotPurchaseMainTypes"
                                id="not_purchase_main_type"
                                name="not_purchase_main_type"
                                placeholder="Selecciona tipos de compra"
                        />
                    </div>
                    <hr style="height:1px;border:none;color:#333;background-color:#333;">
                    <div class="form-group">
                        <!-- Geounits de destino -->
                        <label for="purchase_destinations" class="font-weight-bold">Aplica a los siguientes destinos de la compra</label>
                        <purchase-destinations
                            @error="onComponentError"
                            @update="onPurchaseDestinationsUpdate"
                            :selectedValues="selectedPurchaseDestinations"
                            id="purchase_destinations"
                            name="purchase_destinations"
                        />
                    </div>
                    <div class="form-group">
                        <!-- No Geounits de destino -->
                        <label for="purchase_destinations" class="font-weight-bold">NO aplica a los siguientes destinos de la compra</label>
                        <purchase-destinations
                                @error="onComponentError"
                                @update="onNotPurchaseDestinationsUpdate"
                                :selectedValues="selectedNotPurchaseDestinations"
                                id="not_purchase_destinations"
                                name="not_purchase_destinations"
                        />
                    </div>
                    <hr style="height:1px;border:none;color:#333;background-color:#333;">
                    <div class="form-group">
                        <!-- Pais del cliente -->
                        <label for="user_country" class="font-weight-bold">Aplica a los siguientes paises del cliente (según IP)</label>
                        <div>
                            <user-country-selector
                                    @error="onComponentError"
                                    @update="onUserCountryUpdate"
                                    :selectedValues="selectedUserCountry"
                                    id='user_country'
                                    name='user_country'
                                    label="name"
                                    trackBy="id"
                                    placeholder='Selecciona paises'
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <!-- NO Pais del cliente -->
                        <label for="not_user_country" class="font-weight-bold">NO aplica a los siguientes paises del cliente (según IP)</label>
                        <div>
                            <user-country-selector
                                    @error="onComponentError"
                                    @update="onNotUserCountryUpdate"
                                    :selectedValues="selectedNotUserCountry"
                                    id='not_user_country'
                                    name='not_user_country'
                                    label="name"
                                    trackBy="id"
                                    placeholder='Selecciona paises'
                            />
                        </div>
                    </div>
                    <hr style="height:1px;border:none;color:#333;background-color:#333;">
                    <div class="form-group">
                        <label for="provider_id_in_input" class="font-weight-bold">Provider ids in</label>
                        <provider-input
                                @error="onComponentError"
                                @update="onProviderIdsUpdate"
                                :selectedValues="selectedProviderIds"
                                id="provider_id_in_input"
                                name="provider_id_in"
                                placeholder="enter provider ids seperated by commas"
                        />
                    </div>
                    <div class="form-group">
                        <label for="provider_id_not_in_input" class="font-weight-bold">Provider ids not in </label>
                        <provider-input
                                @error="onComponentError"
                                @update="onProviderNotInIdsUpdate"
                                :selectedValues="selectedNotInProviderIds"
                                id="provider_id_not_in_input"
                                name='provider_id_not_in'
                                placeholder="enter provider ids seperated by commas"
                        />
                    </div>

                  <!-- BRANDS / MARCAS RULES -->
                  <hr style="height:1px;border:none;color:#333;background-color:#333;">
                  <div class="form-group">
                    <!-- marcas incluidas -->
                    <label for="brand_id" class="font-weight-bold">Aplica a las siguientes marcas</label>
                    <BrandsSelector
                      @error="onComponentError"
                      @update="onBrandsUpdate"
                      :selectedValues="selectedBrands"
                      id="brand"
                      name="brand"
                      label="name"
                      trackBy="id"
                      placeholder="Selecciona marcas"
                    />
                  </div>
                  <div class="form-group">
                    <!-- NO marcas -->
                    <label for="not_brand_id" class="font-weight-bold">NO aplica a las siguientes marcas</label>
                    <BrandsSelector
                      @error="onComponentError"
                      @update="onNotBrandsUpdate"
                      :selectedValues="selectedNotInBrands"
                      id="not_brand_id"
                      name="not_brand_id"
                      label="name"
                      trackBy="id"
                      placeholder="Selecciona marcas"
                    />
                  </div>
                </section>

                <section>
                    <hr style="height:1px;border:none;color:#333;background-color:#333;">
                    <div class="form-group">
                        <!-- Call Site SCR or Confirmation Communications -->
                        <label for="system" class="font-weight-bold">Sistema</label>
                        <SystemSelector
                            @error="onComponentError"
                            @update="onSystemUpdate"
                            :selectedValue="selectedSystem"
                            id="system"
                            name="system"
                            placeholder="Selecciona la opción deseada"
                        />
                      <p>Por defecto se muestra en ambos sistemas (SCR y comunicaciones)</p>
                    </div>

                    <hr style="height:1px;border:none;color:#333;background-color:#333;">
                    <div class="form-group">
                        <!-- Tipo de plantilla -->
                        <label for="budget" class="font-weight-bold">Sesiones de tipo presupuesto (quote)</label>
                        <BudgetSelector
                            @error="onComponentError"
                            @update="onBudgetUpdate"
                            :selectedValue="selectedBudgetNotificationType"
                            id="budget"
                            name="budget"
                            placeholder="Selecciona la opción deseada"
                        />
                    </div>
                </section>

                <div class="text-center">
                    <button type="button" @click="sendData" class="btn btn-primary">Enviar</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import ToggleSwitch from '@/components/Form/ToggleSwitch.vue'
    import Textarea from '@/components/Form/Textarea.vue'
    import PurchaseMainTypeSelector from '@/components/Form/PurchaseMainTypeSelector.vue'
    import LabelInput from '@/components/Form/LabelInput.vue'
    import UserCountrySelector from '@/components/Form/UserCountrySelector.vue'
    import RulesManager from '@/data-managers/RulesManager.js'
    import NotificationValidator from '@/validators/NotificationValidator.js'
    import TypeSelector from '@/components/Form/TypeSelector.vue'
    import PurchaseDestinations from '@/components/Form/PurchaseDestinations.vue'
    import ProviderInput from '@/components/Form/ProviderInput.vue'
    import BudgetSelector from '@/components/Form/BudgetSelector.vue'
    import BrandsSelector from '@/components/Form/BrandsSelector.vue'
    import SystemSelector from '@/components/Form/SystemSelector.vue'

    export default {
        name: 'edit-notification',
        components: {
            'toggle-switch' : ToggleSwitch,
            'text-area' : Textarea,
            'purchase-main-type-selector' : PurchaseMainTypeSelector,
            'label-input' : LabelInput,
            'user-country-selector' : UserCountrySelector,
            'type-selector' : TypeSelector,
            'purchase-destinations' : PurchaseDestinations,
            'provider-input'        : ProviderInput,
            'BudgetSelector' : BudgetSelector,
            'BrandsSelector' : BrandsSelector,
            'SystemSelector' : SystemSelector,

        },
        data () {
            return {
                notification : {},
                errorMessages : [],
                successMessage : '',
            };
        },
        computed: {
            enabledIsChecked : function () {
                return this.notification.enabled === '1';
            },
            selectedPurchaseMainTypes : function () {
                let rule = RulesManager.getRuleByOperator('main_type', 'in', this.notification.rules);
                return RulesManager.getValues(rule);
            },
            selectedNotPurchaseMainTypes : function () {
                let rule = RulesManager.getRuleByOperator('main_type', 'not in', this.notification.rules);
                return RulesManager.getValues(rule);
            },
            selectedUserCountry : function () {
                let rule = RulesManager.getRuleByOperator('user_country_by_ip', 'in', this.notification.rules);
                return RulesManager.getValues(rule);
            },
            selectedNotUserCountry : function () {
                let rule = RulesManager.getRuleByOperator('user_country_by_ip', 'not in', this.notification.rules);
                return RulesManager.getValues(rule);
            },
            selectedPurchaseDestinations : function () {
                let rule = RulesManager.getRuleByValues('destination_geounit_id', 'equal', [true], this.notification.rules);
                let values = RulesManager.getParameterValues(rule, 'geo_unit_ids');
                if (Array.isArray(values)) {
                    values = values.join(',');
                }
                return values;
            },
            selectedNotPurchaseDestinations : function () {
                let rule = RulesManager.getRuleByValues('destination_geounit_id', 'equal', [false], this.notification.rules);
                let values = RulesManager.getParameterValues(rule, 'geo_unit_ids');
                if (Array.isArray(values)) {
                    values = values.join(',');
                }
                return values;
            },
            selectedProviderIds()
            {
                let rule = RulesManager.getRuleByValues('provider_id', 'equal', [true], this.notification.rules);
                let values = RulesManager.getParameterValues(rule, 'provider_ids');
                if (Array.isArray(values)) {
                    values = values.join(',');
                }
                return values;
            },
            selectedNotInProviderIds()
            {
                let rule = RulesManager.getRuleByValues('provider_id', 'equal', [false], this.notification.rules);
                let values = RulesManager.getParameterValues(rule, 'provider_ids');
                if (Array.isArray(values)) {
                    values = values.join(',');
                }
                return values;
            },
            selectedBudgetNotificationType: function () {
                let rule_is_budget = RulesManager.getRuleByValues('budget', 'equal', [true], this.notification.rules);
                if (rule_is_budget !== '') {return 1;}
                let rule_not_budget = RulesManager.getRuleByValues('budget', 'not matches', [false], this.notification.rules);
                if (rule_not_budget !== '') {return 2;}
                return null;
            },
            selectedBrands : function () {
              let rule = RulesManager.getRuleByOperator('brand_id', 'in', this.notification.rules);
              return RulesManager.getValues(rule);
            },
            selectedNotInBrands : function () {
              let rule = RulesManager.getRuleByOperator('brand_id', 'not in', this.notification.rules);
              return RulesManager.getValues(rule);
            },
            selectedSystem: function () {
                let rule = RulesManager.getRuleByValues('system', 'in', ['scr'], this.notification.rules);
                if (rule !== '' && rule !== null) {return 'scr';}
                rule = RulesManager.getRuleByValues('system', 'in', ['communications'], this.notification.rules);
                if (rule !== '' && rule !== null) {return 'communications';}
                return null;
            },
        },
        methods: {

            /********* Métodos asociados a eventos *********/

            onComponentError (message) {
                this.errorMessages.push(message);
            },
            onNameUpdate (value) {
                this.notification.name = value;
            },
            onTypeUpdate (value) {
                this.notification.type = value;
            },
            onDescriptionUpdate (value) {
                this.notification.description = value;
            },
            onLabelIdUpdate (value) {
                this.notification.labelId = value;
            },
            onEnabledUpdate (value) {
                this.notification.enabled = value ? "1" : "0";
            },
            onPurchaseMainTypeUpdate (values) {
                this.notification.rules = RulesManager.handleRuleByOperator("main_type", "in", values, null, this.notification.rules);
            },
            onProviderIdsUpdate (values){
                let provider_ids = values.replace(" ", "").split(",");
                let parameters = [{"provider_ids":provider_ids}];
                this.notification.rules = RulesManager.handleRuleByParameters("provider_id", "equal", [true], parameters, this.notification.rules);
                },
            onProviderNotInIdsUpdate(values){
                let provider_ids = values.replace(" ", "").split(",");
                let parameters = [{"provider_ids":provider_ids}];
                this.notification.rules = RulesManager.handleRuleByParameters("provider_id", "equal", [false], parameters, this.notification.rules);
                },
            onNotPurchaseMainTypeUpdate (values) {
                this.notification.rules = RulesManager.handleRuleByOperator("main_type", "not in", values, null, this.notification.rules);
            },
            onUserCountryUpdate (values) {
                this.notification.rules = RulesManager.handleRuleByOperator("user_country_by_ip", "in", values, null, this.notification.rules);
            },
            onNotUserCountryUpdate (values) {
                this.notification.rules = RulesManager.handleRuleByOperator("user_country_by_ip", "not in", values, null, this.notification.rules);
            },
            onPurchaseDestinationsUpdate (values) {
                let destinations = values.replace(" ", "").split(",");
                let parameters = [{"geo_unit_ids":destinations}];
                this.notification.rules = RulesManager.handleRuleByParameters("destination_geounit_id", "equal", [true], parameters, this.notification.rules);
            },
            onNotPurchaseDestinationsUpdate (values) {
                let destinations = values.replace(" ", "").split(",");
                let parameters = [{"geo_unit_ids":destinations}];
                this.notification.rules = RulesManager.handleRuleByParameters("destination_geounit_id", "equal", [false], parameters, this.notification.rules);
            },
            onBudgetUpdate(value){
                let parameters = [value];
                switch (value) {
                    case '1':
                        this.notification.rules = RulesManager.handleRuleByOperator("budget", "not matches", [false], null, this.notification.rules);
                        this.notification.rules = RulesManager.handleRuleByParameters("budget", "equal", [true], parameters, this.notification.rules);
                        break;
                    case '2':
                        this.notification.rules = RulesManager.handleRuleByOperator("budget", "equal", [false], null, this.notification.rules);
                        this.notification.rules = RulesManager.handleRuleByParameters("budget", "not matches", [false], parameters, this.notification.rules);
                        break;
                    default:
                        this.notification.rules = RulesManager.handleRuleByOperator("budget", "not matches", [false], null, this.notification.rules);
                        this.notification.rules = RulesManager.handleRuleByOperator("budget", "equal", [false], null, this.notification.rules);
                }
            },
            onBrandsUpdate (values) {
                this.notification.rules = RulesManager.handleRuleByOperator("brand_id", "in", values, null, this.notification.rules);
            },
            onNotBrandsUpdate (values) {
                this.notification.rules = RulesManager.handleRuleByOperator("brand_id", "not in", values, null, this.notification.rules);
            },
            onSystemUpdate(value) {
                // possible value: scr, communications, ''
                this.notification.rules = RulesManager.handleRuleByOperator("system", "in", [false], null, this.notification.rules);
                switch (value) {
                    case 'scr':
                        this.notification.rules = RulesManager.handleRuleByOperator("system", "in", ["scr"], null, this.notification.rules);
                        break;
                    case 'communications':
                        this.notification.rules = RulesManager.handleRuleByOperator("system", "in", ["communications"], null, this.notification.rules);
                        break;
                    default:
                        this.notification.rules;
                }
            },

            /******************** Misc **********************/

            sendData () {
                if (this.validateNotification()) {
                    if (this.notification.id) {
                        this.updateNotification();
                    } else {
                        this.createNotification();
                    }
                }
                this.scrollToTop();
            },

            validateNotification () {
                this.successMessage = '';
                this.errorMessages = NotificationValidator.validate(this.notification);
                return this.errorMessages.length == 0;
            },

            scrollToTop() {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            },

            /************ Métodos de gestión de los datos de la notificación **************************/

            initNotification() {
                if (this.$route.name == 'editNotification') {
                    axios
                        .get('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_notifications_api_rest/Notification/index?id=' + this.$route.params.id)
                        .then(response => {
                            if (response.data.result) {
                                this.notification = response.data.data
                            } else {
                                this.errorMessages.push("Se ha producido un error al consultar la notificación.");
                            }
                        }).catch(error => {
                            this.errorMessages.push("Se ha producido un error al consultar la notificación. (" + error + ")");
                        });
                } else {
                    this.notification = {
                        "id": "",
                        "rules": JSON.stringify({"rules":[]}),
                        "name": "",
                        "description": "",
                        "labelId": "",
                        "type": "",
                        "enabled": "0"
                    };
                }
            },
            createNotification() {
                axios
                    .post(
                        'https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_notifications_api_rest/Notification/index', this.notification
                    ).then(response => {
                    if (response.data.result){
                        this.notification = response.data.data;
                        this.successMessage = "Notificación creada correctamente";
                    } else {
                        this.errorMessages.push("Se ha producido un error al crear la notificación.");
                    }
                }).catch(error => {
                    this.errorMessages.push("Se ha producido un error al crear la notificación. (" + error + ")");
                });
            },
            updateNotification() {
                axios
                    .put(
                        'https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_notifications_api_rest/Notification/index', this.notification
                    ).then(response => {
                    if (response.data.result) {
                        this.successMessage = "Notificación actualizada correctamente";
                    } else {
                        this.errorMessages.push("Se ha producido un error al actualizar la notificación.");
                    }
                }).catch(error => {
                    this.errorMessages.push("Se ha producido un error al actualizar la notificación. (" + error + ")");
                })
            }
        },

        /***********************************************************/

        created () {
            this.initNotification();
        }
    }
</script>
